export interface IOfficerSettings {
    id: number,
    // name: string,
    backgroundColor: string,
    color: string,
    borderColor: string
}